<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-paste"></i>
          Server
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WEBCastle</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Server</a>
          </li>
      </ul>
    </div>
    <router-view @refresh="refresh()"></router-view>
    <b-card>
      <!-- <template slot="header">
        <i class='fa fa-align-justify'></i> Server List
        <b-button v-if="only_select != true" class="float-right" variant='success' @click="Download">Download</b-button>
      </template> -->
      <b-card v-show="so.adv">
        <!-- <b-row>
          <b-col>
            <b-form-group label="Usage Mode">
              <b-form-radio-group id="radio-group-2" v-model="so.opt.mode" v-b-tooltip.hover title="Please enter the Usage Mode you want to search for">
                <b-form-radio value="2" @click="so.sv=`mode`">Block Mode</b-form-radio>
                <b-form-radio value="1" @click="so.sv=`mode`">Detect Mode</b-form-radio>
                <b-form-radio value="0" @click="so.sv=`mode`">Off</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row> -->
        <b-row>
          <b-col md="12">
            <b-form-group label="Nickname" label-for="ph_code" v-b-tooltip.hover title="Please enter the nickname you want to search for">
              <b-form-input @keyup.native.enter="refresh()" v-model="so.opt.nickname"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            Registration From
            <b-form>
              <date-picker v-model="so.opt.created_at_sd" style="width: 80%" :lang="custom.lang.en" type="date" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
          <span>~</span>
          <b-col md="4">
            Registration To
            <b-form>
              <date-picker v-model="so.opt.created_at_ed" style="width: 80%" :lang="custom.lang.en" type="date" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-col>
        </b-row>
        <b-form-group class="float-right">
          <b-button size="sm" variant="primary" @click="refresh" > Search </b-button>
          <b-button size="sm" variant="secondary" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="default" @click="so.adv = false"> Cancel </b-button>
        </b-form-group>
      </b-card>
      <b-row>
        <b-col sm="3" v-if="only_select">
          <b-button size="sm" variant="primary" @click="multi_all"> Select All </b-button>
          <b-button size="sm" variant="warning" @click="multi_clear"> Clear </b-button>
        </b-col>
        <b-col sm="3" v-else>
          <span class="text-center" v-b-tooltip.hover title="Specify the number of views on one page">
            Show
            <select v-model="so.perPage" @change="refresh">
              <option value="15">Default 15</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </span>
        </b-col>
        <b-col sm="3">
          <!-- <b-checkbox class="float-right" v-model="is_show_dashboard">대시보드</b-checkbox> -->
        </b-col>
        <b-col sm="6">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :disabled="so.adv" :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='nickname';so.skt='nickname';so.adv=false;so.sv=''">Nickname</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='url';so.skt='url';so.adv=false;so.sv=''">URL</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input :disabled="so.adv" v-model="so.sv"  @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="so.adv = !so.adv"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"> Detail Search</i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table
        class="table-responsive table_add"
        v-if="!is_show_dashboard"
        :tbody-tr-class="rowClass"
        ref="_wc_agent_list"
        responsive="sm"
        striped hover small fixed
        :items="getItems"
        :fields="fields"
        :current-page="so.currentPage"
        empty-text="not found"
        :per-page="so.perPage"
        v-show="show"
        :sortBy="so.sk"
        @row-clicked="multi_click"
        style="cursor:pointer;"
        >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
        <template slot="id" slot-scope="row">
          {{only_select != true ? startRow - row.index : ''}}
          <b-form-checkbox :disabled="agent_id == row.item.id" v-if="only_select" v-model="row.item.check" @change="multi_one($event, row)"></b-form-checkbox>
        </template>

        <template slot="is_alive" slot-scope="row">
          <b-badge variant="success" v-if="pong.list.indexOf(row.item.id) > -1">Online</b-badge>
          <b-badge v-else variant="secondary">Offline</b-badge>
        </template>
        <template slot="mode" slot-scope="row">
          <!-- <b-badge @click="modal_multi = true" v-if="row.item.manage_id && row.item.manage_id > 0" variant="dark">Multiplexing(?)</b-badge> -->
          <b-badge v-if="row.item.mode == 0" variant="secondary">Off</b-badge>
          <b-badge v-else-if="row.item.mode == 1" variant="warning">Detect</b-badge>
          <b-badge v-else-if="row.item.mode == 2" variant="danger">Block</b-badge>
          <b-badge v-else>None</b-badge>
        </template>
        <template slot="server" slot-scope="row">
          <a href="javascript:void(0)" class="a_tag" @click="detail(row.item)">
            <span v-if="!row.item.ip_addr_public || !row.item.ip_addr_private">{{row.item.ip_addr}}</span>
            <span v-else>
              <span v-if="row.item.ip_addr_public">
                <span v-if="row.item.ip_addr_public == row.item.ip_addr_private">
                  {{ row.item.ip_addr_public }}
                </span>
                <span v-else>
                  {{ row.item.ip_addr_public }} /  {{ row.item.ip_addr_private }}
                </span>
              </span>
              <span v-else>
                {{ row.item.ip_addr_private }}
              </span>
            </span>
          </a>
          <b-badge class="ml-2" v-if="row.item.created_at == row.item.updated_at" variant="primary">New</b-badge>
        </template>
        <template slot="nickname" slot-scope="row">
          {{row.item.nickname}}
        </template>
        <template slot="domain" slot-scope="row">
          <span style="cursor:pointer" v-if="row.item.policy.domains && row.item.policy.domains.length">
            <b-badge v-if="mode_count(row.item, { mode : 'DetectionOnly' }) > 0" variant="warning">Detect : {{mode_count(row.item, { mode : 'DetectionOnly' })}}</b-badge>
            <b-badge v-if="mode_count(row.item, { mode : 'On' }) > 0" variant="danger">Block : {{mode_count(row.item, { mode : 'On' })}}</b-badge>

            <b-badge v-if="policy_has_default(row.item)" variant="dark">Default</b-badge>
            <b-badge v-if="policy_has_custom(row.item)" variant="primary">
              More {{policy_has_custom(row.item)}} domain
            </b-badge>

            <b-button style="padding:2px !important;" @click="modal_domain = true; modal_domain_info = row.item.policy" v-if="row.item.policy.domains.length > 1" size="sm" variant="light">
              <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
            </b-button>

            <!-- <b-badge v-if="mode_count(row.item, { mode : 'DetectionOnly' }) > 0" variant="warning">Detect : {{mode_count(row.item, { mode : 'DetectionOnly' })}}</b-badge>
            <b-badge v-if="mode_count(row.item, { mode : 'On' }) > 0" variant="danger">Block : {{mode_count(row.item, { mode : 'On' })}}</b-badge>
            <b-badge v-if="mode_count(row.item, { mode : 'On' }) + mode_count(row.item, { mode : 'DetectionOnly' }) < 1" variant="dark">Off</b-badge>
            <b-button @click="modal_domain = true; modal_domain_info = row.item.policy" v-if="row.item.policy.domains.length > 1" size="sm" variant="light">
              <span class="font_14 text-info"><i class="fas fa-question-circle"></i></span>
            </b-button> -->
          </span>
        </template>
        <template slot="version" slot-scope="row">
          <strong>
            {{row.item.version}}
          </strong>
        </template>
        <template slot="select" slot-scope="row">
          <b-button size="sm" @click="detail(row.item)" >Check</b-button>
          <b-button size="sm" v-if="row.item.is_alive" @click="modal_del = true; del_info = row.item" variant="danger">Remove</b-button>
        </template>
      </b-table>
      <hr>
      <template v-if="!show">
        <b-card>
          <tr>
            <th>No server installed</th>
          </tr>
        </b-card>
      </template>
      <b-row v-if="!is_show_dashboard">
        <b-col class="md-8">
          <b-pagination size="sm" align="center" :limit="so.perPage" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">" />
        </b-col>
      </b-row>
      <b-modal title="Delete"  class="modal-danger" v-model="modal_del" @ok="remove" @cancel="del_nickname = '';" header-bg-variant="danger" ok-variant="danger">
        <p> Agent deletion from the server does not automatically delete it Server recommends deleting first  </p>
        <p> If deleted, the firewall will not be processed.  </p>
        <p> <b> * Check Server Name </b> </p>
        <p> Delete Server Nickname : {{del_info.nickname}}  </p>
        <b-form-input v-model="del_nickname" placeholder="Typing The name of the server you want to unregister"></b-form-input>
      </b-modal>
      <b-modal title="Usage Domain" v-model="modal_domain" @ok="modal_domain = false" header-bg-variant="info" ok-only>
        <b-table striped hover small fixed class="table-responsive table_add" :items="using_domain" :fields="domain_manage_fields" empty-text="not found">
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template slot="is_alive" slot-scope="row">
            <b-badge v-if="row.item.is_alive" variant="success">Enable</b-badge>
            <b-badge v-else variant="default">Disable</b-badge>
          </template>
          <template slot="domain" slot-scope="row">{{row.item.domain}} <b-badge v-if="row.item.temp" variant="danger">Un Saved</b-badge></template>
          <template slot="mode" slot-scope="row">
            <b-badge v-if="row.item.mode == 'Off'" variant="light">Off</b-badge>
            <b-badge v-else-if="row.item.mode == 'DetectionOnly'" variant="warning">Detect</b-badge>
            <b-badge v-else-if="row.item.mode == 'On'" variant="danger">Block</b-badge>
            <b-badge v-else>None</b-badge>
          </template>
          <template slot="level" slot-scope="row">{{row.item.level}}</template>
        </b-table>
      </b-modal>
      <b-modal title="Using Multiplexing" v-model="modal_multi" @ok="modal_multi = false" header-bg-variant="warning" ok-only>
        <h5>Managed by a multiplexed firewall policy</h5>
      </b-modal>
    </b-card>
    <hr v-if="is_show_dashboard">
    <b-row v-if="is_show_dashboard">
      <b-col sm="3" v-for="(x, index) in module_list" :key="'agent_'+index" class="text-dark">
        <b-card
          footer="Card Footer"
          footer-tag="footer"
          :footer-bg-variant="(pong.list.indexOf(x.id) > -1 ? 'success' : 'dark')"
          footer-border-variant="light"
          :class="(pong.list.indexOf(x.id) > -1 ? 'bg-success' : 'bg-dark') + ' text-center'">
          <b-row style="position: absolute; top : -26px; padding: 5px; left : 9px;">
            <p style="padding-left: 10px; text-align: left; min-width: 150px; border-radius: 5px 5px 0 0; border-top: solid 1px gray; border-left: solid 1px gray; border-right: solid 1px gray;" :class="(pong.list.indexOf(x.id) > -1 ? 'bg-success text-dark' : 'bg-dark text-white')">Public : {{ x.ip_addr_public || '-' }}</p>
          </b-row>
          <b-row style="position: absolute; top : 0px; padding: 0 5px 5px 5px; left : 9px;">
            <p style="padding-left: 10px; text-align: left; margin-bottom: 10px; min-width: 150px; border-radius: 0 0 5px 0; border: solid 1px gray;" :class="(pong.list.indexOf(x.id) > -1 ? 'bg-success text-dark' : 'bg-dark text-white')">Private : {{ x.ip_addr_public || '-' }}</p>
          </b-row>
          <b-row style="cursor:pointer; margin-top : 10%;">
            <span @v-if="x.is_alive" @click="modal_del = true; del_info = x" class="delete_button" style="padding:3px;width:15px; position: absolute; left : 90%; font-size:1.2em; top : 0px;">
              X
            </span>
            <div class="w-100" @click="modal_domain = true; modal_domain_info = x.policy">
              <b-progress height="1.2rem" style="width: 90%; margin:0 0 0 0;" :max="mode_count(x, { mode : 'On' }) + mode_count(x, { mode : 'DetectionOnly' })">
                <b-progress-bar :value="mode_count(x, { mode : 'On' })" variant="warning">
                  <span>Block: <strong>{{ mode_count(x, { mode : 'On' }) }}</strong></span>
                </b-progress-bar>
                <b-progress-bar :value="mode_count(x, { mode : 'DetectionOnly' })" variant="danger">
                  <span>Detect: <strong>{{ mode_count(x, { mode : 'DetectionOnly' }) }}</strong></span>
                </b-progress-bar>
              </b-progress>
              <span class="text-info">
                <i style="cursor:pointer; position:absolute; right:8px; top: 40px;" class="fas fa-question-circle"></i>
              </span>
            </div>
          </b-row>
          <!-- <hr class="w-50"> -->
          <br>
          <b-row  @click="detail(x)" style="cursor: pointer;">
            <b-col>
              {{x.nickname}}
            </b-col>
          </b-row>
          <!-- {{x}} -->
          <!-- <hr> -->
          <template #footer>
              <b-row v-if="pong.list.indexOf(x.id) > -1" class="text-center">
                <b-col sm="6">
                  <small>RAM
                    <span v-if="x.status_ram">({{ x.status_ram[x.status_ram.length - 1] || 0 }} %)</span>
                  </small>
                </b-col>
                <b-col sm="6">
                  <small>CPU
                    <span v-if="x.status_cpu">({{ x.status_cpu[x.status_cpu.length - 1] || 0 }} %)</span>
                  </small>
                </b-col>
            </b-row>
            <b-row v-if="pong.list.indexOf(x.id) > -1">
                <b-col sm="6">
                  <canvas class="chart chart-line" :id="'ram_'+x.id" height="30" width="80"></canvas>
                </b-col>
                <b-col sm="6">
                  <canvas class="chart chart-line" :id="'cpu_'+x.id" height="30" width="80"></canvas>
                </b-col>
            </b-row>
            <b-row v-else>
                <b-col>
                  <h6>Offline</h6>
                </b-col>
            </b-row>
          </template>
        </b-card>
      </b-col>
    </b-row>
    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
